import { getPeaksAnnotation } from './getPeaksAnnotation.js';

export const JsGraph = {
  getPeaksAnnotation,
};
